import { create } from 'zustand';
import type { ActionResult } from '../types';

interface ActionStoreState {
  completed: Record<string, ActionResult>;
  markDone: (actionId: string, result: ActionResult) => void;
  getResult: (actionId: string) => ActionResult | null;
  /**
   * Wipe all completed-action results. Called from the identity-change path
   * in useAuth.ts (sign-out, sign-in as a different account, or a resolved
   * session whose entity/user differs from the previous one) — never on a
   * same-identity token refresh. This is defense-in-depth alongside
   * namespacing the actionId itself: an LLM-generated id is not a safe cache
   * key on its own, so both the reset and the namespacing are required, not
   * either/or.
   */
  clearActions: () => void;
}

export const useActionStore = create<ActionStoreState>((set, get) => ({
  completed: {},
  markDone: (actionId, result) =>
    set((state) => ({ completed: { ...state.completed, [actionId]: result } })),
  getResult: (actionId) => get().completed[actionId] ?? null,
  clearActions: () => set({ completed: {} }),
}));
